import { forwardRef, ForwardedRef } from "react";
import {
  Grid2 as Grid,
  Box,
  Modal as MuiModal,
  Button,
  Stack,
} from "@mui/material";
import { ModalRef } from "@shared/components";
import { useModalController } from "@shared/components/Modal/controller";
import { modalStyle } from "@shared/components/Modal/styles";

type ModalProps = {
  onConfirm: () => void;
  onClose: () => void;
};

export const ModalSubmit = forwardRef(
  ({ onConfirm, onClose }: ModalProps, ref: ForwardedRef<ModalRef>) => {

    const { isOpen, handleClose } = useModalController(ref, {
      onClose,
    });

    return (
      <MuiModal open={isOpen} onClose={handleClose} keepMounted>
        <Box sx={modalStyle}>
          <Grid container spacing={3}>
            <Stack>
              <Box>
                <h2>Build no IOS enviada para loja com sucesso!</h2>
                <p>
                  A build foi enviada para a loja com sucesso. Aguarde de 5 a 10
                  minutos para que a build seja processada e enviada para
                  TestFlight.
                </p>
              </Box>
            </Stack>
            <Stack
              direction="row"
              spacing={2}
              justifyContent="flex-end"
              width="100%"
            >

              <Button type="submit" variant="contained" onClick={onConfirm}>
                Continuar
              </Button>
            </Stack>
          </Grid>
        </Box>
      </MuiModal>
    );
  }
);
